import * as CubiqTS from "shared/cubiq-model-multi-asset";

export class FilterModel {
  public static readonly All: any = {};

  public get(requested: string): any {
    // no filtering
    return FilterModel.All;
  }
}
